module.exports = __webpack_public_path__ + "static/img/logo.31e2ccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.jpg
// module id = EIBy
// module chunks = 57